var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cartCount()
    ? _c(
        "div",
        [
          _c("CartSummary"),
          _vm.cartCount()
            ? _c("div", { staticClass: "row align-items-center" }, [
                _c(
                  "div",
                  { staticClass: "col col-md-4" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "main-btn",
                        attrs: { to: { name: "homepage" } },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.capitalize(
                                _vm.$t("cart_continue_with_buying")
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "col col-md-4 ml-md-auto" }, [
                  _c(
                    "button",
                    {
                      staticClass: "next-step btn btn-purple w-100",
                      class: { disabled: _vm.nextStepDisabled() },
                      attrs: { dusk: "cart-next-step", type: "submit" },
                      on: {
                        click: function ($event) {
                          return _vm.validate()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("btn_bill")) + " ")]
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }